import BlueprintBuilder from './BlueprintBuilder';
import { ButtonFieldBuilder, CheckboxGroupFieldBuilder, ConsentFieldBuilder, DateFieldBuilder, DropdownFieldBuilder, DynamicDropdownFieldBuilder, InformationFieldBuilder, MoneyFieldBuilder, NumberFieldBuilder, PhoneFieldBuilder, RadioFieldBuilder, SignatureFieldBuilder, TextFieldBuilder, YearMonthFieldBuilder, } from './FieldBuilder';
import FieldGroupBuilder from './FieldGroupBuilder';
import SectionBuilder from './SectionBuilder';
import SectionGroupBuilder from './SectionGroupBuilder';
import SubsectionBuilder from './SubsectionBuilder';
export function generateBlueprintBuilders(SeedBlueprintProviders) {
    return {
        aBlueprint() {
            return new BlueprintBuilder(SeedBlueprintProviders);
        },
        aSectionGroup() {
            return new SectionGroupBuilder(SeedBlueprintProviders);
        },
        aSection() {
            return new SectionBuilder(SeedBlueprintProviders);
        },
        aStep() {
            return new SectionBuilder(SeedBlueprintProviders);
        },
        aSubsection() {
            return new SubsectionBuilder(SeedBlueprintProviders);
        },
        aFieldGroup() {
            return new FieldGroupBuilder(SeedBlueprintProviders);
        },
        aRepeatableFieldGroup({ nodeId }) {
            return new FieldGroupBuilder(SeedBlueprintProviders).makeRepeatable({ nodeId });
        },
        aTextField() {
            return new TextFieldBuilder(SeedBlueprintProviders);
        },
        aDateField() {
            return new DateFieldBuilder(SeedBlueprintProviders);
        },
        aYearMonthField() {
            return new YearMonthFieldBuilder(SeedBlueprintProviders);
        },
        // TODO @questionnaireBuilder Should this be type AgreeField?
        aConsentField() {
            return new ConsentFieldBuilder(SeedBlueprintProviders);
        },
        aNumberField() {
            return new NumberFieldBuilder(SeedBlueprintProviders);
        },
        aPhoneField() {
            return new PhoneFieldBuilder(SeedBlueprintProviders);
        },
        aMoneyField() {
            return new MoneyFieldBuilder(SeedBlueprintProviders);
        },
        aRadioField() {
            return new RadioFieldBuilder(SeedBlueprintProviders);
        },
        aDropdownField() {
            return new DropdownFieldBuilder(SeedBlueprintProviders);
        },
        aCheckboxGroupField() {
            return new CheckboxGroupFieldBuilder(SeedBlueprintProviders);
        },
        aDynamicDropdownField(dynamicOptions) {
            return new DynamicDropdownFieldBuilder(SeedBlueprintProviders).withDynamicOptions(dynamicOptions);
        },
        anInformationField() {
            return new InformationFieldBuilder(SeedBlueprintProviders);
        },
        aButtonField() {
            return new ButtonFieldBuilder(SeedBlueprintProviders);
        },
        aSignatureField(participantRole) {
            return new SignatureFieldBuilder(SeedBlueprintProviders, participantRole);
        },
    };
}
export { blueprintBuilderFunctions } from './BuildersWithSeed';
